module.exports = {
  title: 'dawndrums',
  description: 'Embedded Systems Designer',
  keywords: 'dawndrums, artificial intelligence, embedded systems, open source, Linux, security, privacy, mobile system',
  url: 'https://dawndrums.tn',
  seoImage: 'https://dawndrums.tn/images/dd_logo_v3.png',
  color: '#000000'
};
